// Foundations
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

// Services
import {PackageService} from '../../../services/package.service';
import {AnalyticsService} from '../../../services/analytics.service';

// Models
import { PackageItem } from 'src/app/models/package/package-item.model';
import { OrderRequestItem, OrderRequestPriceInfo } from 'src/app/models/package/order-request.model';
import { FormGroup } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';


@Component({
  selector: 'app-package-order-summary',
  templateUrl: './package-order-summary.component.html',
  styleUrls: ['./package-order-summary.component.scss'],
})
export class PackageOrderSummaryComponent implements OnInit, OnDestroy {
  // #region -> Property - IO <-
  // ----------

  @Input() orderRequest$: Observable<OrderRequestItem>;
  orderRequest: OrderRequestItem = new OrderRequestItem({});
  orderRequestSubscription: Subscription;
  @Output() orderRequestChange = new EventEmitter<OrderRequestItem>();

  @Output() changeStep = new EventEmitter<number>();

  showCustomOption = false;
  tipOptions = [];
  selectedTipOption = null;
  form: FormGroup;
  customTipAmount;



  orderRequestPriceInfo: OrderRequestPriceInfo = {
    subtotal: 0,
    taxRate: 0,
    taxTotal: 0,
    tipTotal: 0,
    orderTotal: 0,
    total: 0
  };

  // ----------
  // #endregion

  /////////////////////////////

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private packageService: PackageService,
    private _analytics: AnalyticsService,
    private currencyPipe: CurrencyPipe

  ) {}

  // #region -> Lifecycle <-
  // ----------

  ngOnInit(): void {
    //
    this.orderRequestSubscription = this.orderRequest$.subscribe(
      (newOrderRequest) => {
        this.orderRequest = this.orderRequest.update({
          ...newOrderRequest.json(),
        });

        //
        this.parseTipInfo();

        //
        this.orderRequestPriceInfo = this.orderRequest.calculatePriceInfo();

        // Trigger change detection when mutated.
        this.changeDetectorRef.markForCheck();
      }
    );
  }

  ngOnDestroy(): void {
    //
    this.orderRequestSubscription.unsubscribe();
  }

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Public Method <-
  // ----------

  togglePackageDeletion(packageItem: PackageItem): void {
    //
    this.orderRequest = this.orderRequest.removePackage(packageItem);
    this.orderRequestPriceInfo = this.orderRequest.calculatePriceInfo();
    this.changeDetectorRef.markForCheck();
  }

  proceed() {
    if (this.selectedTipOption){
      let tipAmount = 0;
      if (this.selectedTipOption === 'Custom' && this.customTipAmount){
        if (typeof this.customTipAmount === 'string' ) {
          tipAmount = parseFloat(this.customTipAmount.replace(/[^\d.]/g, ''));
        }
        else if (this.customTipAmount) {
          tipAmount = parseFloat(this.customTipAmount);
        }
       }
      else if (this.selectedTipOption !== 'Custom') {
         const tipPercent = parseFloat(this.selectedTipOption);
         tipAmount = (tipPercent / 100) * this.orderRequestPriceInfo.subtotal;
       }
      this.orderRequest.hasTip = true;
      this.orderRequest.tipAmount = tipAmount;
      this.orderRequest.selectedTipOption = this.selectedTipOption;
    } else {
      this.orderRequest.hasTip = false;
      this.orderRequest.tipAmount = 0;
      this.orderRequest.selectedTipOption = this.selectedTipOption;
    }
    // Send the updated "order request"
    this.orderRequestChange.emit(this.orderRequest);
    this.changeStep.emit(4);
  }

  back() {
    this._analytics.logButtonTap('package_backFromOrderSummary');

    this.changeStep.emit(0);
  }

  parseTipInfo(){
    this.tipOptions = [];
    this.showCustomOption = false;
    const franchise = this.orderRequest.selectedLocation;
    if (franchise.hasDefaultTipItem){
      const tipOptions = franchise.merchant.merchTippercent.split('|');
      for (const tipOption of tipOptions){
        if (isNaN(+tipOption)){
            this.showCustomOption = true;
        }
        else if (+tipOption > 0){
          this.tipOptions.push(+tipOption);
        }
      }
      if (this.orderRequest.selectedTipOption){
          this.selectedTipOption = this.orderRequest.selectedTipOption;
          if (this.selectedTipOption === 'Custom'){
            this.customTipAmount = this.currencyPipe.transform(this.orderRequest.tipAmount,
              '$', true, '1.2-2');
          }
      }
    }
  }

  setTipPercent(tipPercent){
    if (this.selectedTipOption === tipPercent){
      this.selectedTipOption = null;
    }
    else {
      this.selectedTipOption = tipPercent;
    }
  }

  transformCustomTip(element){
    if (typeof this.customTipAmount === 'string') {
      this.customTipAmount = this.currencyPipe.transform(
        this.customTipAmount.replace(/[^\d.]/g, ''),
        '$', true, '1.2-2');
    }
    element.target.value = this.customTipAmount;
  }
  // ----------
  // #endregion

  /////////////////////////////

}
